import styled from 'styled-components';

export const RegisterContent = styled.div`
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
      padding: 50px 30px;
      border-radius: 10px;
`;
